import { initialState } from 'modules/loading-manager/loading-manager.reducer';

import { LOGIN } from '../../states/states.constants';
import { LOADING_STATE, SET_LOADING_MANAGER_STATE } from 'modules/loading-manager/loading-manager.constants';
import { ILoadingManagerStoreProps } from 'modules/loading-manager/loading-manager.types';
import { setLoadingManagerState } from 'modules/loading-manager/loading-manager.actions';
import { SWITCH_PREVIEW_STATE_HOST, SwitchPreviewStateAction } from '@sitegen/common/types/root-actions';

type Actions = ReturnType<typeof setLoadingManagerState> | SwitchPreviewStateAction;

export const loadingManager = (state = initialState, action: Actions): ILoadingManagerStoreProps => {
    switch (action.type) {
    case SWITCH_PREVIEW_STATE_HOST:
        if (action.payload !== LOGIN || state.loading === LOADING_STATE.LOADED) {
            return {
                ...state,
                loading: LOADING_STATE.LOADED
            };
        } else {
            return {
                ...state,
                loading: LOADING_STATE.NOT_LOADED
            };
        }
    case SET_LOADING_MANAGER_STATE:
        return {
            ...state,
            loading: LOADING_STATE.LOADED
        };

    default: {
        return state;
    }
    }
};

export default loadingManager;
